import * as React from 'react';
import styled from 'styled-components';

import {NavItem} from '../../NavItem';
import {BREAKPOINTS, ComponentTextStyle} from '../../styles';
import {TextButton} from '../../Button';
import {ComponentMStyling} from '../../styles';
import {defaultOnMouseDownHandler} from '../../common';
import {MenuButton, MenuNavigationItemTypeItem} from '../types';
import {TooltipWrapper} from "../../Tooltips";
import HyperLink from '../../HyperLink/HyperLink';

const NavContainer = styled.div`
  display: none;
  margin: auto 0 auto auto;
  align-items: center;
  height: 64px;

  a {
    text-decoration: none;
  }

  ${BREAKPOINTS.MEDIUM} {
    display: flex;
  }

  ${BREAKPOINTS.LARGE} {
    height: 80px;
  }

  button,
  div {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledButton = styled(TextButton)`
  height: 40px;
  margin: 0 8px;

  ${ComponentMStyling(ComponentTextStyle.Bold, 'unset')}
`;

type Props = {
  items?: MenuNavigationItemTypeItem[];
  action?: MenuButton;
};

const RightSideNav = ({items, action}: Props): React.ReactElement<Props> => {
  const getNavItem = (item: MenuNavigationItemTypeItem) => {
    if (item?.disabled) {
      return (
        <NavItem as={TextButton} className="disabled" key={item?.label}>
          {item?.label}
        </NavItem>
      );
    } else {
      return (
        <NavItem
          as={HyperLink}
          external={true}
          $variant="styleless"
          target='_self'
          href={item?.to || ''}
          key={item?.label}
          onMouseDown={defaultOnMouseDownHandler}
          onClick={(e:React.MouseEvent) => item.action && item.action(e)}>
          {item?.label}
        </NavItem>
      );
    }
  };



  return (
    <NavContainer>
      {items?.reverse().map(no => getNavItem(no))}

      {
        action && !action.tooltip &&
        <StyledButton variant="secondary" onClick={action?.action} {...{...action, action: undefined}}>
          {action.label}
        </StyledButton>
      }
      {
        action && !!action.tooltip &&
          <TooltipWrapper {...action.tooltip}>
            <StyledButton variant="secondary" onClick={action?.action} {...{...action, action: undefined}}>
              {action.label}
            </StyledButton>
          </TooltipWrapper>
      }

    </NavContainer>
  );
};

export default RightSideNav;
